import { colorStrings, mediaQueriesBP } from "@iewcasia/Utilities/variables";
import { listStyles as styles } from "@insite/content-library/Widgets/ProductList/ProductListCardList";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

styles.wrapper = {
    ...styles.wrapper,
    css: css`
        &:has([data-test-selector="productListCards_Table"]) {
            margin-top: 20px;
            border-top: 1px solid ${getColor("common.border")};
            padding: 40px 0;
        }

        &:has([data-test-selector="productListCards_List"]) {
            margin-top: 20px;
            border-top: 1px solid ${getColor("common.border")};
        }
    `,
};
